import React from "react"
import {AlertDialog, Button, Text} from "native-base"

function AlertBox({header = "", body = "",closeButton = false, isOpen = false, onClose = null, textButton1 = null, textButton2 = null, onPressButton1 = null, onPressButton2 = null }) {
  return <AlertDialog motionPreset='fade' onClose={onClose} isOpen={isOpen} isCentered height="calc(100vh)">
    <AlertDialog.Content>
      {closeButton && (<AlertDialog.CloseButton />)}
      <AlertDialog.Header>{header}</AlertDialog.Header>
      <AlertDialog.Body>
        {body}
      </AlertDialog.Body>
      <AlertDialog.Footer>
        {onPressButton2 != null &&
          (<Button style={{ minWidth: '50px', borderColor: 'darkolivegreen' }} variant="outline" onPress={onPressButton2}>
            <Text style={{ color: 'darkolivegreen' }}>{textButton2}</Text>
          </Button>)}
        <Button onPress={onPressButton1} style={{ backgroundColor: 'darkolivegreen', marginLeft: '5px', minWidth: '50px' }}>
        {textButton1}
        </Button>
      </AlertDialog.Footer>
    </AlertDialog.Content>
  </AlertDialog>;
  }

  export default AlertBox;